import TableCalculations from './TableCalculations';

export default TableCalculations;
